"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FieldWrapper = _interopRequireDefault(require("./FieldWrapper"));

var _styles = require("./styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _designLanguage = require("@doordash/design-language");

var _utilities = require("@doordash/utilities");

var _utils = require("../utils");

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var numberOfLines = function numberOfLines(_ref) {
  var isMultiline = _ref.isMultiline,
      type = _ref.type;

  if (isMultiline && type === 'text') {
    return Number.isInteger(isMultiline) ? isMultiline : 2;
  }

  return 1;
};
/**
 * https://developers.google.com/web/fundamentals/accessibility/semantics-aria/aria-labels-and-relationships
 * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html
 * https://developers.google.com/web/fundamentals/design-and-ui/input/forms/
 */


var RawTextField = function RawTextField(_ref2) {
  var autoFocus = _ref2.autoFocus,
      isDisabled = _ref2.isDisabled,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      _onChange = _ref2.onChange,
      onKeyUp = _ref2.onKeyUp,
      onKeyDown = _ref2.onKeyDown,
      onClick = _ref2.onClick,
      value = _ref2.value,
      label = _ref2.label,
      isLabelHidden = _ref2.isLabelHidden,
      isRequired = _ref2.isRequired,
      error = _ref2.error,
      type = _ref2.type,
      title = _ref2.title,
      description = _ref2.description,
      hint = _ref2.hint,
      placeholder = _ref2.placeholder,
      autoComplete = _ref2.autoComplete,
      renderBeforeContent = _ref2.renderBeforeContent,
      renderAfterContent = _ref2.renderAfterContent,
      renderConnectedBefore = _ref2.renderConnectedBefore,
      renderConnectedAfter = _ref2.renderConnectedAfter,
      isMultiline = _ref2.isMultiline,
      isResizeable = _ref2.isResizeable,
      maxLength = _ref2.maxLength,
      minLength = _ref2.minLength,
      size = _ref2.size,
      pattern = _ref2.pattern,
      isRounded = _ref2.isRounded,
      accessibilityDescribedBy = _ref2.accessibilityDescribedBy,
      hasDefaultRenderContent = _ref2.hasDefaultRenderContent,
      props = _objectWithoutProperties(_ref2, ["autoFocus", "isDisabled", "onFocus", "onBlur", "onChange", "onKeyUp", "onKeyDown", "onClick", "value", "label", "isLabelHidden", "isRequired", "error", "type", "title", "description", "hint", "placeholder", "autoComplete", "renderBeforeContent", "renderAfterContent", "renderConnectedBefore", "renderConnectedAfter", "isMultiline", "isResizeable", "maxLength", "minLength", "size", "pattern", "isRounded", "accessibilityDescribedBy", "hasDefaultRenderContent"]);

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  var inputTextStyles = (0, _utils.getThemeFieldTextStyles)({
    theme: theme,
    size: size,
    styleType: 'Input'
  });
  var propsToForward = (0, _utilities.getPropsToForward)({
    props: props,
    prefixesToForward: ['data-', 'aria-']
  });
  var isTextArea = isMultiline && type === 'text';
  return /*#__PURE__*/_react["default"].createElement(_FieldWrapper["default"], {
    label: label,
    description: description,
    hint: hint,
    error: error,
    isDisabled: isDisabled,
    isLabelHidden: isLabelHidden,
    renderBeforeContent: renderBeforeContent,
    renderAfterContent: renderAfterContent,
    renderConnectedBefore: renderConnectedBefore,
    renderConnectedAfter: renderConnectedAfter,
    accessibilityDescribedBy: accessibilityDescribedBy,
    size: size,
    isRounded: isRounded,
    isAdjustableHeight: isTextArea,
    hasDefaultRenderContent: hasDefaultRenderContent,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_styles.InputContent, _extends({
    theme: theme
  }, propsToForward, {
    tag: isTextArea ? 'textarea' : 'input',
    title: title,
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value, event);
    },
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    type: type // Only one of `<label>` and `aria-label` should be implemented
    // Using two or more together (e.g., a hidden <label> and a
    // duplicate title attribute) can cause information to be
    // repeated by a screen reader.
    // http://webaim.org/techniques/forms/advanced#hiddenlabel
    ,
    "aria-label": isLabelHidden ? label : null,
    required: isRequired,
    autoComplete: autoComplete,
    disabled: isDisabled,
    autoFocus: autoFocus,
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    numberOfLines: numberOfLines({
      isMultiline: isMultiline,
      type: type
    }),
    maxLength: maxLength,
    minLength: minLength,
    isResizeable: isResizeable,
    inputSize: size,
    pattern: pattern,
    mobileInputTextStyles: inputTextStyles.mobile,
    desktopInputTextStyles: inputTextStyles.desktop
  })));
};

RawTextField.Sizes = _FieldWrapper["default"].Sizes;
RawTextField.propTypes = _objectSpread(_objectSpread({}, (0, _lodash["default"])(_FieldWrapper["default"].propTypes, ['children'])), {}, {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].instanceOf(Date)]).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onKeyUp: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  autoFocus: _propTypes["default"].bool,
  isRequired: _propTypes["default"].bool,
  pattern: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  type: _propTypes["default"].string,
  title: _propTypes["default"].string,
  isMultiline: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  maxLength: _propTypes["default"].number,
  minLength: _propTypes["default"].number,
  isResizeable: _propTypes["default"].bool,

  /**
   * autoComplete
   * @type {String}
   * Used to provide a hint to the browser how to autofill
   * an input for use in a form
   * https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#inappropriate-for-the-control
   */
  autoComplete: _propTypes["default"].string,
  isRounded: _propTypes["default"].bool,
  accessibilityDescribedBy: _propTypes["default"].string,

  /**
   * Certain Field types, like "SearchField" and "PasswordField", have
   * render content built in that provides visual or behavioral context
   * for the type of input the field is being utilized for.
   * The presence of this render content has been built into these types
   * and should not be considered "custom" render content, which has an
   * underlying effect on the padding and ultimately rendered size of
   * the Field across themes.
   */
  hasDefaultRenderContent: _propTypes["default"].bool
});
RawTextField.defaultProps = {
  isResizeable: true,
  size: RawTextField.Sizes.Medium,
  isRounded: false
};
var _default = RawTextField;
exports["default"] = _default;